export type IReport =
  | (IBaseReport & {
      data: IReportedPost
    })
  | (IBaseReport & {
      data: IReportedComment
    })
  | (IBaseReport & {
      data: IReportedProfile
    })

export interface IBaseReport {
  data: IReportedPost | IReportedComment | IReportedProfile
  reason_types: REPORT_REASON[]
  reported_entity_id: string
  reported_entity_type: REPORT_TYPE
  reports_count: number
  reviewed_at: number
  reviewed_by: string
  status: REPORT_STATUS
}

export interface IProject {
  created_at: number
  file_id: string
  original_post_id: string | null
  profile_id: string
  profile_picture_id: string
  project_id: string
  status: string
  type: string
  updated_at: number
  username: string
}

export interface IReportedPost {
  created_at: number
  description: string
  file_id: string
  nb_comments: number
  post_id: string
  profile_id: string
  profile_picture_id: string
  project_id: string
  status: REPORT_COMMENT_STATUS
  type: string
  updated_at: number
  username: string
}

export interface IReportedComment {
  content: string
  created_at: number
  parent_post_comment_id: string[]
  post_comment_id: string
  post_id: string
  profile_id: string
  profile_picture_id: string
  status: REPORT_COMMENT_STATUS
  tagged_profiles_ids: string[]
  text: string
  updated_at: number
  username: string
}

export interface IReportedProfile {
  bio: string
  created_at: number
  display_name: string
  nb_followers: number
  nb_follows: number
  preferred_language: string
  profile_id: string
  profile_picture_file_id: string
  status: REPORT_COMMENT_STATUS
  updated_at: number
  username: string
}

export enum REPORT_TYPE {
  COMMENT = 'comment',
  POST = 'post',
  PROFILE = 'profile',
}

export enum REPORT_REASON {
  DO_NOT_LIKE = 'do-not-like',
  FAKE_NEWS = 'fake-news',
  HARASSMENT = 'harassment',
  HATE_SPEECH = 'hate-speech',
  INTELLECTUAL_PROPERTY = 'intellectual-property',
  SALE_PROHIBITED = 'sale-prohibited',
  SCAM = 'scam',
  SELF_HARM = 'self-harm',
  SEXUAL_ACTIVITY = 'sexual-activity',
  SPAM = 'spam',
  VIOLENCE = 'violence',
}

export enum REPORT_STATUS {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REJECTED = 'rejected',
}

export enum REPORT_COMMENT_STATUS {
  PENDING_ADMIN_REVIEW = 'pending_admin_review',
  PUBLISHED = 'published',
  REMOVED_BY_ADMIN = 'removed_by_admin',
  REMOVED_BY_USER = 'removed_by_user',
}
